import {
  BrowserRouter as Router,
  Route,
  Routes,
  Outlet,
  Navigate,
} from 'react-router-dom';
import AppWrapper from './wrappers/AppWrapper';
import configData from './config/config.json';

import { LicenseInfo } from '@mui/x-license';
import CustomerList from './pages/hexa_api/customer/CustomerList';
import CustomerDetail from './pages/hexa_api/customer/CustomerDetail';
import Home from './pages/home';
import Statistics from './pages/hexa_api/statistics/Statistics';
import ApplicationDetail from './pages/hexa_api/customer/applications/ApplicationDetail';
import WalletDetail from './pages/hexa_api/customer/wallets/WalletDetail';
import CustomerStatistics from './pages/hexa_api/customer/CustomerStatistics';
import SubtagsList from './pages/hexa_api/subtags/SubtagsList';
import MonitoringList from './pages/hexa_api/monitoring/MonitoringList';
import CustomDopList from './pages/hexa_api/custom_dops/CustomDopList';
import CustomDopDetail from './pages/hexa_api/custom_dops/CustomDopDetail';
import StatisticsSelection from './pages/hexa_api/statistics/selection/StatisticsSelection';
import BusinessBaseStatistics from './pages/business_base/statistics/BusinessBaseStatistics';
import { StatisticsTab } from './pages/hexa_api/statistics/StatisticsTab';
import { BusinessBaseStatisticsTab } from './pages/business_base/statistics/BusinessBaseStatisticsTab';
import DailyControlHome from './pages/daily_control/DailyControlHome';
import DailyControlUserList from './pages/daily_control/users/DailyControlUserList';
import DailyControlCustomerList from './pages/daily_control/customers/DailyControlCustomerList';

LicenseInfo.setLicenseKey(configData.MUI_X_LICENSE_KEY);

const AppRoutes = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<AppWrapper />}>
          <Route index element={<Home />} />
          <Route path="monitoring" element={<Outlet />}>
            <Route index element={<MonitoringList />} />
          </Route>
          <Route path="custom_dops" element={<Outlet />}>
            <Route index element={<CustomDopList />} />
            <Route path=":customDopId" element={<Outlet />}>
              <Route index element={<CustomDopDetail />} />
            </Route>
          </Route>
          <Route path="daily_control" element={<Outlet />}>
            <Route index element={<DailyControlHome />} />
            <Route path="customers" element={<Outlet />}>
              <Route index element={<DailyControlCustomerList />} />
            </Route>
            <Route path="users" element={<Outlet />}>
              <Route index element={<DailyControlUserList />} />
            </Route>
          </Route>
          <Route path="subtags" element={<Outlet />}>
            <Route index element={<SubtagsList />} />
          </Route>
          <Route path="stats" element={<Outlet />}>
            <Route index element={<StatisticsSelection />} />
            <Route path="watchbase" element={<Outlet />}>
              <Route
                index
                element={<Navigate to={StatisticsTab.Names} replace />}
              />
              <Route path=":tab" element={<Statistics />} />
            </Route>
            <Route path="businessbase" element={<Outlet />}>
              <Route
                index
                element={
                  <Navigate to={BusinessBaseStatisticsTab.MostSearched} replace />
                }
              />
              <Route path=":tab" element={<BusinessBaseStatistics />} />
            </Route>
          </Route>
          <Route path="api_customers" element={<Outlet />}>
            <Route index element={<CustomerList />} />
            <Route path=":customerId/statistics" element={<Outlet />}>
              <Route index element={<CustomerStatistics />} />
            </Route>
            <Route path=":customerId" element={<Outlet />}>
              <Route index element={<CustomerDetail />} />
              <Route
                path="applications/:applicationId"
                element={
                  <ApplicationDetail
                    isDialog={false}
                    open={true}
                    onClose={() => {}}
                    applicationListUpdate={() => {}}
                  />
                }
              />
              <Route
                path="wallets/:walletId"
                element={
                  <WalletDetail/>
                }
              />
            </Route>
          </Route>
        </Route>
      </Routes>
    </Router>
  );
};

export default AppRoutes;
